import { getIndustryListApi } from "@/api/services/admin/learning-content";
import { TGetIndustryListReqDto } from "@/api/services/admin/learning-content/dtos/get-industry-list.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";

/**
 * Custom hook for fetching industry list with pagination
 * Uses React Query for caching and automatic refetching
 */
export const useIndustryList = (params?: TGetIndustryListReqDto) => {
  const query = useQuery({
    queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_LIST, params],
    queryFn: () => getIndustryListApi(params),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
